import { ActionMenuConfig, ActionMenuResolverContext } from '@milanote/roma/application';
import { BoardLink01Icon, AtSignIcon, FaceHappyIcon, Divider02Icon } from '@milanote/roma-icons';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { getElementType } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { ElementType } from '../../../../../../../common/elements/elementTypes';

export type InsertMenuContext = ActionMenuResolverContext & {
    locale: string;
    element?: ImMNElement;
    insertEmoji: () => void;
    insertDividerLine: () => void;
    insertBoardLink: () => void;
    insertMention: () => void;
};

const isNotTaskType = (context: InsertMenuContext) => {
    const elementType = getElementType(context.element);

    return elementType !== ElementType.TASK_TYPE && elementType !== ElementType.TASK_LIST_TYPE;
};

export const insertMenuConfig: ActionMenuConfig<InsertMenuContext> = [
    {
        id: 'insert',
        items: [
            {
                type: 'action',
                icon: FaceHappyIcon,
                id: 'emoji',
                localeKey: 'emoji',
                onAction: (context) => context.insertEmoji(),
            },
            {
                type: 'action',
                icon: Divider02Icon,
                id: 'dividerLine',
                localeKey: 'dividerLine',
                availabilityPredicate: isNotTaskType,
                onAction: (context) => context.insertDividerLine(),
            },
            {
                type: 'action',
                icon: BoardLink01Icon,
                id: 'linkBoard',
                localeKey: 'boardLink',
                onAction: (context) => context.insertBoardLink(),
            },
            {
                type: 'action',
                icon: AtSignIcon,
                id: 'mention',
                localeKey: 'mentions',
                availabilityPredicate: isNotTaskType,
                onAction: (context) => context.insertMention(),
            },
        ],
    },
];
